import { Modal } from '@/components/ui/Modal'
import { WordDetail, WordDetailSkeleton, WORD_DETAIL_HEADING_ID } from '@/components/word/WordDetail'
import { fetchWord } from '@/api/words'
import { useResource } from '@/hooks/useResource'

interface WordDetailModalProps {
  languageId: number
  wordId: number
  onClose: () => void
}

/**
 * The word detail page as a dialog — used from a flashcard so a reviewer can
 * check the full entry without leaving the session.
 */
export function WordDetailModal({ languageId, wordId, onClose }: WordDetailModalProps) {
  const { data: word, loading, error } = useResource(
    () => fetchWord(languageId, wordId).then((res) => res.data.data),
    [languageId, wordId],
    'Could not load word details. Close and try again.',
  )

  return (
    <Modal open onClose={onClose} labelledBy={WORD_DETAIL_HEADING_ID} size="lg">
      <div className="min-h-40">
        {loading && <WordDetailSkeleton />}

        {error && (
          <p role="alert" className="font-serif text-base text-muted font-light text-center py-12">
            {error}
          </p>
        )}

        {word && !error && <WordDetail word={word} headingLevel={2} />}
      </div>
    </Modal>
  )
}
